module.exports = __webpack_public_path__ + "static/media/montserrat-latin-800-normal.47adf161.woff2";